import React, {useEffect, useState} from 'react';
import "./landing.css"
import  "./button.css"
import {ImgCarousel} from "../../components/ImgCarousel";
import {Products} from "../../components/Products";
import {Us} from "../../components/Us"
import {Info} from "../../components/Info";
import Typography from "@mui/material/Typography";
import {Banner} from "../../components/Banner";
import {Header} from "../../components/Header";
import { Metrics } from '../../components/Metrics';

const Landing = () => {

    const [containerActive, setContainerActive] = useState(false);

    useEffect(() => {
        const delay = 500;
        setTimeout(() => {
            setContainerActive(true);
        }, delay);
    }, []);

    return (
        <>
            <Header variant={1} />
            <ImgCarousel />
            <div className="main-container" >
                <div >
                    <Us />
                </div>

                <div>
                    <Info />
                </div>

                <div className='typewriter-container'>
                    <div className={`page-container ${containerActive ? 'active' : ''}`}>
                        <Typography
                            sx={{
                                color: '#383d46',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '2.9rem',
                                fontWeight: 700,
                                textShadow: '3px 3px #E9E9E9',
                            }}
                        >
                            Te ofrecemos soluciones para asegurar tu
                        </Typography>
                        <h1>
                            &nbsp;<span className="typewriter"></span>
                        </h1>
                    </div> 
                </div>

                <div id="info-container" className="info-container">

                    <Products />

                    <a href="/Portafolio" className="btn">
                        <svg width="277" height="62">
                            <defs>
                                <linearGradient id="grad1">
                                    <stop offset="0%" stopColor="#FF6C00" />
                                    <stop offset="100%" stopColor='#F68431FF' />
                                </linearGradient>
                            </defs>
                            <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="266"
                                height="50"></rect>
                        </svg>
                        <span>Ver más productos</span>
                    </a>
                </div>
            </div>

            <Banner title="¿Tienes preguntas?" />

            <div className='metrics-title'>
                <Typography
                    sx={{
                        color: '#ff6c00',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '15px',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '3px',
                    }}
                >
                    ¿Por qué elegirnos?
                </Typography>
                <Typography
                    sx={{
                        color: '#3b3b3b',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '40px',
                        fontWeight: '500'
                    }}
                >
                    Roca en números
                </Typography>
            </div>

            <div className='metrics'>
                <Metrics />
            </div>
        </>
    );

};

export default Landing;